import { render } from "./AddTeams.vue?vue&type=template&id=02ae8d44&scoped=true"
import script from "./AddTeams.vue?vue&type=script&lang=js"
export * from "./AddTeams.vue?vue&type=script&lang=js"

import "./AddTeams.vue?vue&type=style&index=0&id=02ae8d44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ae8d44"]])

export default __exports__